import(/* webpackMode: "eager" */ "/apps/jenkins_home/workspace/sxm-web-de-cms/sxm-web-de-cms-app/PROD-CORP-BUILD/cdn/de-sxm-www/src/app/[...slug]/error.tsx");
